export default "__VITE_ASSET__B$XEVHUK__"